import { decode as base64_decode, encode as base64_encode } from "base-64";
import { v4 as uuid } from "uuid";
import { sha256 } from "js-sha256";

export function jsonToBase64(objectOrString) {
  var toEncode = objectOrString;
  if (typeof objectOrString === "object")
    toEncode = JSON.stringify(objectOrString);
  const encoded = base64_encode(toEncode);
  return encoded;
}

export function base64ToJson(base64String) {
  const decoded = base64_decode(base64String);
  return JSON.parse(decoded);
}

// Decodes a remote-shell command result. The raw value is untrusted text
// coming straight from the device via the CMD API, so this never throws -
// callers get back a status they can render instead of an uncaught
// rejection. Note: the Python CMD client currently caps RESULT at ~500
// Base64 characters, so "ok" output can be silently cut off mid-line; we
// display exactly what was received and never try to reconstruct the rest.
// Fixing truncation requires the backend/client to widen that field or send
// chunked responses.
export function decodeCommandResult(rawResult) {
  if (rawResult === undefined || rawResult === null) {
    return { status: "missing", text: "" };
  }
  if (rawResult === "") {
    return { status: "empty", text: "" };
  }
  try {
    return { status: "ok", text: base64_decode(rawResult) };
  } catch (error) {
    return { status: "invalid", text: "" };
  }
}

export function getPageData(data, page, limit) {
  const items = data.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });
  return items;
}

export function getDateByFormat(dateString, language) {
  if (dateString && dateString.length > 8 && language.length === 2) {
    let onlyDate = dateString.slice(0, -9);
    let onlyHour = dateString.slice(-8, dateString.length);
    const [day, month, year] = onlyDate.split("/");
    const newDate = new Date(year + "/" + month + "/" + day + " " + onlyHour);
    const date = getDateByLanguage(newDate, language);
    return date;
  }
}

export function getDateByLanguage(date, language) {
  const result =
    language === "en"
      ? date.toLocaleString("en-US")
      : date.toLocaleString("en-GB");
  return result;
}

// The auth API timestamps are ISO 8601 (UTC), unlike the "dd/MM/yyyy HH:mm:ss"
// strings the device APIs return, so they get their own parser and then reuse
// the same per-language formatting as everything else.
export function getIsoDateByLanguage(isoString, language) {
  if (!isoString) return null;
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return null;
  return getDateByLanguage(date, language);
}

export function getDateStringByLanguage(date, language) {
  const result =
    language === "en"
      ? date.toLocaleDateString("en-US") +
        " " +
        [date.getHours(), date.getMinutes(), date.getSeconds()].join(":")
      : date.toLocaleDateString("en-GB") +
        " " +
        [date.getHours(), date.getMinutes(), date.getSeconds()].join(":");
  return result;
}

export function getDate(dateString) {
  let onlyDate = dateString.slice(0, -9);
  let onlyHour = dateString.slice(-8, dateString.length);
  const [day, month, year] = onlyDate.split("/");
  const newDate = new Date(year + "/" + month + "/" + day + " " + onlyHour);
  return newDate;
}

export function theDateIsToday(date) {
  const today = new Date();

  if (
    today.getFullYear() === date.getFullYear() &&
    today.getMonth() === date.getMonth() &&
    today.getDate() === date.getDate()
  ) {
    return true;
  }

  return false;
}

export function getUUId(size = null) {
  const uniqueId = uuid();
  if (size !== null) return uniqueId.slice(0, size);
  else return uniqueId;
}

export function isOnTime(dateTime, delay) {
  let onTime = false;
  const date = getDate(dateTime);
  date.setHours(date.getHours() - 4);
  let ttoday = new Date();
  let diff = ttoday - date;
  if (diff <= delay) {
    onTime = true;
  }
  return onTime;
}

export function stringToSha256(string) {
  return sha256.update(string).hex();
}

export function getGroupedList(data, numCols) {
  if (data !== null && data.length > 0) {
    let groupedList = [];
    let row = [];
    if (data.length < numCols) {
      groupedList.push(data);
    } else {
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (i % numCols === 0 && i > 0) {
          groupedList.push(row);
          row = [];
        }
        row.push(element);
        if (i === data.length - 1) {
          groupedList.push(row);
        }
      }
    }
    return groupedList;
  } else return [];
}
